import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { cancelPaymentMethod, paymentCancelled } from './actions';
import { withTranslation } from 'react-i18next';
import { PaymentTypes } from '../payments/actions';
import queryString from 'query-string';

class Cancelled extends Component {
	componentDidMount() {
		const { location, match, paymentCancelled, cancelPaymentMethod, history } = this.props;
		const paymentType = location.pathname.startsWith('/individual-consultation') ? PaymentTypes.IndividualConsultation : location.pathname.startsWith('/workshop') ? PaymentTypes.Workshop : PaymentTypes.Lesson;

		if (match.params.id) {

			const { reason } = queryString.parse(location.search);
			if (reason) {
				paymentCancelled(reason);
			}

			cancelPaymentMethod(Number(match.params.id), reason, paymentType, history);
		}
	}

	render() {
		const { t } = this.props;

		return <div>
			<div style={{ textAlign: 'center', fontSize: '16px', color: '#0071ac' }}>
				<div>{t('FO_Booking_ProcessingPayment')}</div>
				<FontAwesome name='spinner' spin size='3x' />
			</div>
		</div>;
	}
}

export default connect(null, {
	paymentCancelled,
	cancelPaymentMethod
})(withTranslation()(Cancelled));